import { AppLayout } from "@bcc/components/app-layout";
import { FinanceSettingsView } from "@bcc/components/views/finance-settings-view";

interface InitialSettings {
  tax: {
    defaultCountry: "DE" | "NL";
    deVatId: string;
    nlVatId: string;
    deValidationEnabled: boolean;
    nlValidationEnabled: boolean;
  };
  export: {
    exportFormat: "csv" | "pdf";
    includeTaxDetails: boolean;
    includeLineItems: boolean;
    dateFormat: "EU" | "US";
    numberFormat: "EU" | "US";
  };
  defaults: {
    defaultDateRange: string;
    defaultStatus: string;
  };
  phases: {
    phase1Enabled: boolean;
    phase2Enabled: boolean;
  };
}

export function FinanceSettingsPage() {
  const initialSettings: InitialSettings = {
    tax: {
      defaultCountry: "DE",
      deVatId: "DE123456789",
      nlVatId: "NL123456789B01",
      deValidationEnabled: true,
      nlValidationEnabled: true,
    },
    export: {
      exportFormat: "csv",
      includeTaxDetails: true,
      includeLineItems: true,
      dateFormat: "EU",
      numberFormat: "EU",
    },
    defaults: {
      defaultDateRange: "this-month",
      defaultStatus: "all",
    },
    phases: {
      phase1Enabled: true,
      phase2Enabled: false,
    },
  };

  return (
    <AppLayout>
      <FinanceSettingsView initialSettings={initialSettings} />
    </AppLayout>
  );
}
